// axiosInstance.js
import axios from 'axios';
import config from '../config';
import { getToken } from "../util/Cookies";
import { store } from '../store/store';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to inject token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Get current state from Redux store
    const state = store.getState();
    
    // Extract error code from response if available
    const errorCode = error.response?.data?.code || 
                     error.response?.data?.errorCode || 
                     error.code || 
                     null;

    // Prepare error log data
    const errorLogData = {
      user_type: 'guest',
      platform: 'web',
      error_message: error.message || 'Unknown API error',
      error_code: errorCode, // Added error_code field
      endpoint: error.config?.url || 'unknown',
      method: error.config?.method?.toUpperCase() || 'unknown',
      status_code: error.response?.status,
      request_data: error.config?.data ? 
        (typeof error.config.data === 'string' ? 
          JSON.parse(error.config.data) : 
          error.config.data) 
        : null,
      response_data: error.response?.data,
       stack_trace: error.stack || null
    };

    // Check if user is logged in from Redux store
    if (state.auth.isLoggedIn && state.user.userDetails) {
      errorLogData.user_type = 'user';
      errorLogData.user_id = state.user.userDetails.userId || 
                            state.user.userDetails.id;
    }

    // Send error log to backend
    try {
      await axios.post(`${config.API_BASE_URL}/error-logs`, errorLogData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken() || '',
        },
      });
    } catch (logError) {
      
      console.error('Failed to send error log:', logError);
      // Fallback console log with user info
      console.error('API Error:', {
        ...errorLogData,
        user_logged_in: state.auth.isLoggedIn,
        user_id_from_store: state.user.userDetails?.userId
      });
    }

    // Return the original error for the caller to handle
    return Promise.reject(error);
  }
);

export default axiosInstance;